import SettingsPage from './SettingsPage'
import { settingsMenu } from './sideBarOption'

export { settingsMenu }
export default SettingsPage
